"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataGridHeaderCell", {
    enumerable: true,
    get: function() {
        return DataGridHeaderCell;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useDataGridHeaderCell = require("./useDataGridHeaderCell");
const _renderDataGridHeaderCell = require("./renderDataGridHeaderCell");
const _useDataGridHeaderCellStylesstyles = require("./useDataGridHeaderCellStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const DataGridHeaderCell = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDataGridHeaderCell.useDataGridHeaderCell_unstable)(props, ref);
    (0, _useDataGridHeaderCellStylesstyles.useDataGridHeaderCellStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDataGridHeaderCellStyles_unstable')(state);
    return (0, _renderDataGridHeaderCell.renderDataGridHeaderCell_unstable)(state);
});
DataGridHeaderCell.displayName = 'DataGridHeaderCell';
